import { useState, useEffect } from 'react';

/**
 * Hook to manage the active session stopwatch.
 * HARDENED: Handles potential clock drift by clamping negative durations to zero.
 */
export const useSessionTimer = (activeSession: any, retroactiveDate?: string | null): string => {
    const [elapsed, setElapsed] = useState('00:00');

    useEffect(() => {
        if (activeSession && !activeSession.isRestDay && !retroactiveDate) {
            const interval = setInterval(() => {
                const startTime = activeSession.startTime || activeSession.start_time; 
                if (!startTime) return;
                
                const diff = Math.max(0, new Date().getTime() - new Date(startTime).getTime());
                
                const hours = Math.floor(diff / 3600000);
                const mins = Math.floor((diff % 3600000) / 60000);
                const secs = Math.floor((diff % 60000) / 1000);
                
                if (hours > 0) {
                    setElapsed(`${hours.toString().padStart(2, '0')}:${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`);
                } else {
                    setElapsed(`${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`);
                }
            }, 1000);
            return () => clearInterval(interval);
        } else {
            setElapsed('00:00');
        }
    }, [activeSession, retroactiveDate]);

    return elapsed;
};
